import { LinkButton, Page } from '@/components';
import { Flex, Heading } from '@blockanalitica/ui';
import MarketsTable from './MarketsTable';
import OverviewGraphTabs from './OverviewGraphTabs';
import TopKpis from './TopKpis';

export default function NetworkPage() {
  return (
    <Page>
      <TopKpis />
      <OverviewGraphTabs />
      <Flex flexDirection="column" gap="s">
        <Flex gap="s" justifyContent="space-between" alignItems="center">
          <Heading size="3">Top Markets</Heading>
          <LinkButton to="markets" variant="secondary" size="small">
            View All
          </LinkButton>
        </Flex>
        <MarketsTable p={1} p_size={5} />
      </Flex>
    </Page>
  );
}
